import {
  Modal,
  Table,
  Loader,
  Center,
  Text,
  Anchor,
  Stack,
  Alert,
  Button,
} from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";
import { useAppStore } from "../store/appStore";
import { useHindcast } from "../api/hindcasts";
// Render a specs table value — converts markdown [text](url) links to Anchor
function SpecValue({ value }: { value: string }) {
  const linkMatch = value.match(/\[(.+?)\]\((.+?)\)/);
  if (linkMatch) {
    return (
      <Anchor href={linkMatch[2]} target="_blank" size="sm">
        {linkMatch[1]}
      </Anchor>
    );
  }
  return <Text size="sm">{value}</Text>;
}

export function HindcastInfoModal() {
  const { hindcastInfoOpen, closeHindcastInfo, selectedHindcast } = useAppStore();
  const { data, isLoading, isError, error } = useHindcast(
    hindcastInfoOpen ? selectedHindcast : null
  );

  return (
    <Modal
      opened={hindcastInfoOpen}
      onClose={closeHindcastInfo}
      title={
        <Text fw={600}>{selectedHindcast ?? ""} — Hindcast specification</Text>
      }
      size="xl"
      scrollAreaComponent={undefined}
    >
      {isLoading && (
        <Center h={200}>
          <Loader />
        </Center>
      )}

      {isError && (
        <Alert color="red" title="Error">
          {(error as Error).message}
        </Alert>
      )}

      {data && (
        <Stack gap="md">
          <Table striped withTableBorder withColumnBorders>
            <Table.Tbody>
              {Object.entries(data.specs).map(([key, value]) => (
                <Table.Tr key={key}>
                  <Table.Td fw={600} w="30%" style={{ verticalAlign: "top" }}>
                    {key}
                  </Table.Td>
                  <Table.Td>
                    <SpecValue value={value} />
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>

          {data.details && (
            <Button
              component="a"
              href={data.details}
              target="_blank"
              variant="outline"
              color="blue"
              size="sm"
              leftSection={<IconExternalLink size={16} />}
            >
              View full dataset specification
            </Button>
          )}
        </Stack>
      )}
    </Modal>
  );
}
